import { DateTimeInputField, DateTimeInputFieldProps } from 'app/components/date-selectors/date-time-input-field';
import { getIn, useFormikContext } from 'formik';
import { DateTime } from 'luxon';
import { FieldError } from './field-error';

interface IProps {
  hideValidationErrors?: boolean;
  minimal?: boolean;
}

export const FormikDateTimeInputField = (props: IProps & Omit<DateTimeInputFieldProps, 'value' | 'onChange'>) => {
  const { name, hideValidationErrors, ...inputFieldProps } = props;

  const context = useFormikContext();
  const formValue = getIn(context.values, name as string) as DateTime;

  return (
    <DateTimeInputField {...inputFieldProps} name={name} value={formValue} onChange={handleTimeChange}>
      {!hideValidationErrors && <FieldError name={name as string} />}
    </DateTimeInputField>
  );

  function handleTimeChange(localTime: DateTime | null) {
    context.setFieldValue(name as string, localTime);
    context.setFieldTouched(name as string, true);
  }
};
